import { commonDate } from 'src/helpers'

export const vendor = {
  warehouse: {
    columns: [
      {
        name: 'username',
        field: (row) => {
          return `<a href="/vendor/form/warehouse/form/${
            row.id
          }/${encodeURIComponent(
            row.name
          )}" class="goto-preview-page"><span class="text-weight-bold
          ">${row.name}</span></a> `
        },
        label: 'Nama',
        sortable: true,
        align: 'left',
        rowClass: 'text-left text-no-wrap'
      },

      {
        name: 'email',
        field: (row) => {
          return row.email || '-'
        },
        label: 'Email',
        sortable: true,
        align: 'left',
        rowClass: 'text-left'
      },
      {
        name: 'phone',
        field: (row) => {
          return row.phone || '-'
        },
        label: 'No. Telepon',
        sortable: true,
        align: 'left',
        rowClass: 'text-left'
      },
      {
        name: 'status_active',
        field: row => {
          return {
            ACTIVE: '<div role="alert" class="custom-badge custom-badge-green">Aktif</div>',
            NONACTIVE: '<div role="alert" class="custom-badge custom-badge-red">Tidak Aktif</div>',
            WAITING_ACTIVATION: '<div role="alert" class="custom-badge custom-badge-lilac">Menunggu Aktivasi</div>'
          }[row.status_active] || '<div role="alert" class="custom-badge">Status Kosong</div>'
        },
        label: 'Status Pengguna',
        sortable: true,
        align: 'left',
        rowClass: 'text-left'
      }
    ]
  }
}

function parseDate (date) {
  return date
    ? commonDate({ useDayName: true, date: new Date(date) })
    : '-'
}

export const vendorMainTableWarehouse = {
  visibleColumns: ['name', 'phone', 'email', 'pickupVendor', 'address', 'deletedAt'],
  columns: [
    {
      name: 'name',
      field: (row) => {
        return row.name || '-'
      },
      label: 'Nama',
      sortable: true,
      align: 'left',
      rowClass: 'text-left text-no-wrap'
    },
    {
      name: 'phone',
      field: (row) => {
        return row.phone || '-'
      },
      label: 'No. Telepon',
      sortable: true,
      align: 'left',
      rowClass: 'text-left'
    },

    {
      name: 'email',
      field: (row) => {
        return row.email || '-'
      },
      label: 'Email',
      sortable: true,
      align: 'left',
      rowClass: 'text-left'
    },

    {
      name: 'pickupVendor',
      field: (row) => {
        return row.isLocationPickup
          ? '<div role="alert" class="custom-badge custom-badge-green">Bersedia</div>'
          : '<div role="alert" class="custom-badge custom-badge-red">Tidak Bersedia</div>'
      },
      label: 'Pickup di vendor',
      sortable: true,
      align: 'left',
      rowClass: 'text-left'
    },
    {
      name: 'address',
      field: (row) => {
        return `<div">${row.address}</div>` || '-'
      },

      label: 'Alamat Gudang',
      sortable: true,
      align: 'left',
      rowClass: 'text-left'
    },
    {
      name: 'deletedAt',
      field: row => parseDate(row.deletedAt) || '',
      label: 'Tanggal Nonaktif',
      sortable: true,
      align: 'left'
    }
  ]
}
